import type { ComputedRef } from 'vue'

import { createInjectedState } from './injectedState'

const { provideState, useState } = createInjectedState<number | null>(
  'shared-list-total',
  null
)

/**
 * Announce how many rows the list *has*, as against how many are in hand — a paged select
 * needs it to say that what is loaded is not everything.
 *
 * Provided by the list hook rather than passed as a prop: between the hook and the control
 * that reads the count sit each entity's own wrappers, which would all have to declare and
 * forward it.
 */
export const provideListTotal = provideState

/**
 * How many rows the nearest enclosing list holds in total, or `null` when nobody said —
 * a list hook without a `meta.total`, or a select built outside `useEntitySelect`. Callers
 * must have something to show for `null`; it is not the same as zero.
 */
export const useListTotal: () => ComputedRef<number | null> = useState
